<template>
  <v-card
    v-if="
      (allowedFields.properties || getField('metadata').deprecation_reason) &&
      finalDataItemsHasLength
    "
    :color="backColor"
    border
    class="pa-4 d-flex flex-column overflow-initial"
    elevation="3"
    tile
  >
    <!-- Additional Information -->
    <SectionTitle title="Additional Information" />

    <!--  deprecation_reason (one of a kind)  -->
    <div
      v-if="getField('metadata').deprecation_reason"
      class="d-flex pa-4 data-holder flex-row mt-4 align-center min-height-40"
      style="border: 2px dotted darkorange"
    >
      <b class="width-200">Dataset Deprecation reason</b>
      <div class="d-flex full-width ml-md-12 ml-13">
        <p class="ma-0 bg-warning text-white">
          {{ getField("metadata").deprecation_reason }}
        </p>
      </div>
    </div>
    <!--  dynamically reading all allowed additionalInfo fields and its items -->
    <dataset-array
      v-for="(item, key, index) in finalData"
      :key="item.name + '_' + index + '_' + key"
      :current-field="finalData[key]"
      :current-key="key"
      :current-tooltips="allowedFields['properties'][key]"
      :title="key"
    />
  </v-card>
</template>

<script>
import { isArray } from "lodash-es";
import { mapActions, mapGetters, mapState } from "vuex";

import DatasetArray from "@/components/Records/Record/AdditionalInfo/DatasetArray";
import SectionTitle from "@/components/Records/Record/SectionTitle";

export default {
  name: "AdditionalInfo",
  components: { DatasetArray, SectionTitle },
  props: {
    backColor: {
      default: null,
      type: String,
    },
  },
  data: () => {
    return {
      finalData: {},
      tempData: {},
      finalDataItemsHasLength: true,
    };
  },
  computed: {
    ...mapState("editor", ["allowedFields"]),
    ...mapGetters("record", ["getField", "getRecordType"]),
  },
  async mounted() {
    await this.getAllowedFields({
      type: this.getRecordType,
    });
    await this.initializeData();
    await this.$nextTick();
    this.finalData = this.tempData;
    this.finalDataItemsHasLength = false;
    // Check that all objects have a value, and return false if all are empty.
    // This will prevent the additional info section from being displayed.
    Object.keys(this.finalData).forEach((key) => {
      if (this.finalData[key].length >= 1) {
        this.finalData[key].forEach((item) => {
          this.finalDataItemsHasLength = Object.values(item).some(
            (el) => el !== undefined && el !== null && el !== "",
          );
        });
      }
    });
  },
  methods: {
    ...mapActions("editor", ["getAllowedFields"]),
    async initializeData() {
      const excludedTypes = [
        "associated_tools",
        "data_processes_and_conditions",
        "data_versioning",
        "citation_to_related_publications",
        "data_contact_information",
        "data_access_for_pre_publication_review",
        "data_access_condition",
        "data_curation",
        "data_deposition_condition",
        "data_preservation_policy",
        "resource_sustainability",
        "certifications_and_community_badges",
      ];
      /* istanbul ignore else */
      if (this.allowedFields.properties !== undefined) {
        const allAllowedTypes = Object.keys(
          this.allowedFields.properties,
        ).filter((key) => !excludedTypes.includes(key));
        for (const key of allAllowedTypes) {
          if (
            Object.prototype.hasOwnProperty.call(this.getField("metadata"), key)
          ) {
            this.setAvailableData(this.getField("metadata")[key], key);
          }
        }
      }
    },
    setAvailableData(selectedNode, key) {
      // if received node is not an array
      if (!isArray(selectedNode)) {
        this.tempData[key] = [];
        // Special case this is a string
        if (typeof selectedNode === "string") {
          this.tempData[key].push({ Value: selectedNode });
        }
        else {
          Object.keys(selectedNode).forEach((item_key) => {
            this.tempData[key].push({ [item_key]: selectedNode[item_key] });
          });
        }
        return;
      }
      // if received node is an array
      Object.keys(selectedNode).forEach((item) => {
        if (Object.keys(selectedNode[item]).length) {
          if (Object.keys(this.tempData).includes(key)) {
            this.tempData[key].push(selectedNode[item]);
          }
          else {
            this.tempData[key] = [];
            this.tempData[key].push(selectedNode[item]);
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.data-holder {
  border: 1px lightgrey solid;
}
</style>
